// All needed imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared/shared.module';
import { LegalOwnerComponent } from './legal-owner-component/legal-owner.component';

@NgModule({
  // Declarate the needed components
  declarations: [
    LegalOwnerComponent
  ],
  // Import modules which will be used in this module
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule
  ],
  // Indicate the modules which will be used in other modules
  exports: [
    LegalOwnerComponent
  ]
})
export class Form5Module { }
